// extracted by mini-css-extract-plugin
export default {"desktopNav":"DesktopNavigation_desktopNav__ljMgZ","categoriesMode":"DesktopNavigation_categoriesMode__gRqPi","navContent":"DesktopNavigation_navContent__OP2XL"};